import { render, staticRenderFns } from "./PrintDispatch.vue?vue&type=template&id=5f28af27&"
import script from "./PrintDispatch.vue?vue&type=script&lang=js&"
export * from "./PrintDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrintDispatch.vue"
export default component.exports